import * as React from "react";
import { UserProfileContext } from "./UserProfileProvider";

export const useUserProfileState = () => {
  return React.useContext(UserProfileContext);
};
